// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"5d6340da","459":"660ee983","825":"92838e8a"}[chunkId] + ".chunk.js";
};